goog.provide('el8.appservice.notifier');

goog.require('el8.app.pageLayout');
goog.require('el8.core.service.Notifier');


el8.appservice.notifier = new el8.core.service.Notifier({
    UILayoutFn: function() { return el8.app.pageLayout; }
});

